<form [formGroup]="invoiceLookupForm">

<div class="invoice-lookup-container">
  <div class="labels">
    <p>Invoice List Lookup</p>
    <p>By: </p>
  </div>
  <div>
    <kendo-dropdownlist class="lookupSelection" formControlName="typeSelection"
      [data]="selectionChoice"
      [value]="typeSelection"
      (valueChange)="onChange($event)">
    </kendo-dropdownlist>
  </div>

  <div class="list-panel">
    <textarea formControlName="invoiceList"
              (valueChange)="invoiceListChange($event)"
              kendoTextArea type="text" rows="10" autoSize="true"></textarea>
  </div>

  <div class="view-download-buttons" fxLayoutGap="8px">
    <app-mcl-button primary="true" text="View" (click)="viewClicked($event)"></app-mcl-button>
    <app-mcl-button primary="true" text="Download" (click)="downloadClicked($event)"></app-mcl-button>
  </div>

</div>
</form>
